import Game from "../../Game.js";
import Styler from "../../maze/featurer/Styler.js";
import Spran from "../spran/Spran.js";
import BasicAI from "./ai/BasicAI.js";
import Mob from "./Mob.js";

export default class Door extends Mob {
	constructor(sprites, type, style, horizontal, cellOccupied) {
		let animation;
		if (type === Door.TYPE_DOOR) {
			animation = Door.ANIMATIONS_DOOR;
		} else if (type === Door.TYPE_SPIKE) {
			animation = Door.ANIMATIONS_SPIKE;
		} else if (type === Door.TYPE_SECRET) {
			if (horizontal) {
				animation = Door.ANIMATIONS_SECRET_HORIZONTAL;
			} else {
				animation = Door.ANIMATIONS_SECRET_VERTICAL;
			}
		}

		super(sprites, animation, Door.WALK_STEP);
		/*if (type === Door.TYPE_SECRET) {
			if (horizontal) {
				this.applySheetToEveryAnimation(animation, "fakewall" + style);
			} else {
				this.applySheetToEveryAnimation(animation, "fakewall" + style);
			}
		}*/

		this.cellOccupied = cellOccupied;
		this.width = Game.DOOR_WIDTH;
		this.height = Game.DOOR_HEIGHT;
		this.type = type;
		this.style = style;
		this.horizontal = horizontal;
		this.closed = true;
		

		let traits = {
			clas: "door",
			openDoors: false,
			static: true,
			qi: BasicAI.QI_NONE,
			speed: Mob.WALK_STEP * Game.MULT,
			radius: Mob.RADIUS,
			runspeed: Mob.RUN_STEP * Game.MULT
		}
		this.setMobTraits(traits)



	}

	init() {
		this.mc = jQuery("#template-static").clone();
		this.mc.attr("id", "mob" + Mob.ENUM++);
		this.mc.css({
			width: this.width,
			height: this.height,
		});

		this.initSprites();
	}


	initSprites() {
		// Setta la grandezza dello sprite
		this.clip = jQuery(".js-sprite", this.mc);
		this.clip.width(Game.DOOR_WIDTH);
		this.clip.height(Game.DOOR_HEIGHT * 2);
		this.clip.css("top", -Game.DOOR_HEIGHT);
		this.spran = new Spran(this.sp, this.clip, this.animationsDefinitions);
		this.spran.init();
		if (this.cellOccupied.isLockedDoor()) {
			this.setAnimation("locked");
		} else {
			this.setAnimation("closed");
		}
		if (this.type === Door.TYPE_SECRET) {
			this.clip.css("opacity", Door.OPACITY_SECRET_WALLS)
		}
		this.clip.css("pointer-events", "none");
	}

	setInView(lFlag) {
		if (lFlag) {
			//this.spran.resume(this.defaultAnimation);
			this.spran.resume();
			this.inView = true;
		} else {
			this.spran.pause();
			this.inView = false;
		}
	}



}

//Door.WALK_STEP = 0;
Door.OPACITY_SECRET_WALLS = 0.5;

Door.TYPE_DOOR = "typeExitDoor";
Door.TYPE_SPIKE = "typeExitSpike";
Door.TYPE_SECRET = "typeExitSecret";

Door.ANIMATIONS_DOOR = [
	{
		id: "closed",
		sheet: Styler.DOOR_HORIZONTAL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: -1
			}
		]
	},
	{
		id: "locked",
		sheet: Styler.DOOR_HORIZONTAL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 8,
				time: -1
			}
		]
	},
	{
		id: "open",
		sheet: Styler.DOOR_HORIZONTAL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 1,
				time: 60
			},
			{
				row: 0,
				col: 2,
				time: 60
			},
			{
				row: 0,
				col: 3,
				time: -1
			},
		]
	},
	{
		id: "close",
		sheet: Styler.DOOR_HORIZONTAL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 2,
				time: 60
			},
			{
				row: 0,
				col: 1,
				time: 60
			},
			{
				row: 0,
				col: 0,
				time: -1
			},
		]
	},

]
Door.ANIMATIONS_SPIKE = [
	{
		id: "closed",
		sheet: Styler.DOOR_VERTICAL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 4,
				time: -1
			}
		]
	},
	{
		id: "locked",
		sheet: Styler.DOOR_VERTICAL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 8,
				time: -1
			}
		]
	},
	{
		id: "open",
		sheet: Styler.DOOR_VERTICAL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 5,
				time: 60
			},
			{
				row: 0,
				col: 6,
				time: 60
			},
			{
				row: 0,
				col: 7,
				time: -1
			}
		]
	},
	{
		id: "close",
		sheet: Styler.DOOR_VERTICAL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 6,
				time: 60
			},
			{
				row: 0,
				col: 5,
				time: 60
			},
			{
				row: 0,
				col: 4,
				time: -1
			}
		]
	}
]

Door.ANIMATIONS_SECRET_HORIZONTAL = [
	{
		id: "closed",
		sheet: Styler.FAKEWALL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 6,
				time: -1
			}
		]
	}
]

Door.ANIMATIONS_SECRET_VERTICAL = [
	{
		id: "closed",
		sheet: Styler.FAKEWALL,
		flip: false,
		frames: [
			{
				row: 0,
				col: 0,
				time: -1
			}
		]
	}
]

